import type { ReactNode } from "react";
import { useAnnouncePage } from "../../app/PageTitleContext";

/**
 * What this screen is, said in the bar along the top.
 *
 * <p>This used to draw a heading block at the top of the content: a title, a sentence under it,
 * and a button opposite. That was the first eighty pixels of every screen spent on something the
 * reader already knew — they clicked the thing in the sidebar that brought them here — and it
 * pushed the table they came for below the fold.
 *
 * <p>So the component still exists and still takes the same words; it just puts them somewhere
 * that costs nothing. Pages carry on calling it, which is why the change reached every screen
 * at once rather than screen by screen.
 *
 * <p>{@code actions} is for a screen with nowhere better to put its button. Where a screen has a
 * filter bar the button belongs there, beside the things it is filtered by — see {@link FilterBar}.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
}) {
  useAnnouncePage(title, subtitle);

  if (!actions) {
    return null;
  }
  return <div className="mb-4 flex flex-wrap items-center justify-end gap-2">{actions}</div>;
}
